export var CustomMetrics = {
  name: 'Vexflow-Custom',
  smufl: false,
  glyphs: {}
};